var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"upload-demo",attrs:{"id":_vm.id,"multiple":true,"action":"'' ","show-file-list":false,"on-change":_vm.onchangeFunc,"http-request":_vm.uploadFiles,"limit":100,"file-list":_vm.fileList}})}
var staticRenderFns = []

export { render, staticRenderFns }